import * as React from "react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import SharedComponents from "@audacia-hq/shared/components";

import { useServiceWorker } from "../../context/ServiceWorkerContext";
import Button from "../Button";

interface Props {
  onClose?: (accepted: boolean) => void;
}

const PushNotificationsModal: React.FC<Props> = ({ onClose }) => {
  const { t } = useTranslation("common");
  const {
    pushSubscription, registerPush, unregisterPush, loadingPush,
  } = useServiceWorker();
  const [isOpen, setIsOpen] = useState(false);

  const handleAccept = async () => {
    await registerPush();
    setIsOpen(false);
    onClose?.(true);
  };

  const handleRefuse = async () => {
    await unregisterPush();
    setIsOpen(false);
    onClose?.(false);
  };

  const handleClose = () => {
    setIsOpen(false);
    onClose?.(false);
  };

  useEffect(() => {
    setIsOpen(!loadingPush && !pushSubscription);
  }, [pushSubscription, loadingPush]);

  return (
    <SharedComponents.Modal
      title={t("notifications.push.title")}
      show={isOpen}
      mobileFullscreen={false}
      onClose={handleClose}
    >
      <div className="flex flex-col gap-5 p-4 items-center">
        {t("notifications.push.help")}
        <div className="space-x-2">
          <Button render="simpleRed" size="small" onClick={handleRefuse}>
            {t("common:refuse")}
          </Button>
          <Button render="primary" size="small" onClick={handleAccept}>
            {t("common:accept")}
          </Button>
        </div>
      </div>
    </SharedComponents.Modal>
  );
};

export default PushNotificationsModal;
